import { useTranslation } from 'react-i18next'
import { FaFile, FaFileDownload, FaFileImage, FaFilePdf } from 'react-icons/fa'

import { getAttachmentPreviewKind } from '../../utils/attachmentPreview.utils'

export const AttachmentTypeIcon = ({ kind }) => {
  const className = 'shrink-0 text-lg'

  if (kind === 'pdf') return <FaFilePdf className={`${className} text-red-500`} />
  if (kind === 'image') return <FaFileImage className={`${className} text-emerald-600`} />
  return <FaFile className={`${className} text-slate-500`} />
}

export const AttachmentPreviewContent = ({ file }) => {
  const { t } = useTranslation()
  const previewKind = getAttachmentPreviewKind(file)
  const fileUrl = file.attachment_url
  const fileName = file.original_filename

  if (previewKind === 'image' && fileUrl) {
    return <img src={fileUrl} alt={fileName} className="h-full w-full object-contain" />
  }

  if (previewKind === 'pdf' && fileUrl) {
    return <iframe src={fileUrl} title={fileName} className="h-full w-full border-0 bg-white" />
  }

  return (
    <div className="flex h-full flex-col items-center justify-center gap-4 px-6 text-center">
      <FaFile className="text-5xl text-slate-400" />
      <p className="max-w-md text-sm text-slate-600">{t('support.detail.preview_not_available')}</p>
      {fileUrl ? (
        <a
          href={fileUrl}
          download={fileName}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-2 rounded-md bg-sky-600 px-4 py-2 text-sm text-white hover:bg-sky-700"
        >
          <FaFileDownload />
          {t('support.detail.download_file')}
        </a>
      ) : null}
    </div>
  )
}
